import { defineSlotRecipe } from '@chakra-ui/react'
import { typography } from '@reward-platform/lift/theme/aer_lingus/typography'

export const label = defineSlotRecipe({
  className: 'Label',
  slots: ['labelContainer'],
  base: {
    labelContainer: {
      fontSize: typography.sizes.xsmall,
      fontWeight: typography.weights.medium,
      padding: '0 8px',
      borderRadius: '4px',
      display: 'inline-block',
    },
  },
})
